/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * CVR Optimization: Dynamic Social Proof Counters
 * Updates people viewing and recent purchases counters for urgency
 */
(function() {
  'use strict';

  function initSocialProof() {
    const socialProofContainer = document.querySelector('.product-form__social-proof-below');
    if (!socialProofContainer) return;

    const viewersCountEl = socialProofContainer.querySelector('[data-viewers-count]');
    const productId = socialProofContainer.getAttribute('data-product-id');

    if (!productId) return;

    // Generate deterministic but dynamic-looking numbers based on product ID
    function getViewersCount(productId) {
      const base = parseInt(productId) || 0;
      const hour = new Date().getHours();
      const minute = new Date().getMinutes();
      // Varies between 8-25 based on time and product ID
      return 8 + ((base + hour * 60 + minute) % 17);
    }

    function getPurchasesCount(productId) {
      const base = parseInt(productId) || 0;
      const day = new Date().getDate();
      // Varies between 15-35 based on day and product ID
      return 15 + ((base + day * 7) % 20);
    }

    // Update counter
    if (viewersCountEl) {
      const viewersCount = getViewersCount(productId);
      viewersCountEl.textContent = viewersCount;
    }

    // Update every 30-60 seconds with slight variation
    setInterval(function() {
      if (viewersCountEl) {
        const current = parseInt(viewersCountEl.textContent) || 14;
        const change = Math.random() > 0.5 ? 1 : -1;
        const newCount = Math.max(8, Math.min(25, current + change));
        viewersCountEl.textContent = newCount;
      }
    }, 35000 + Math.random() * 25000);
  }

  /**
   * CVR Optimization: Dynamic Delivery Date
   * Calculates and displays delivery date based on current time
   */
  function initDeliveryPromise() {
    const deliveryDateEl = document.querySelector('[data-delivery-date]');
    if (!deliveryDateEl) return;

    function updateDeliveryDate() {
      const now = new Date();
      const hour = now.getHours();
      const cutoffHour = 23; // 23:00 cutoff

      let deliveryDate = new Date(now);
      
      // If before cutoff, delivery is tomorrow
      // If after cutoff, delivery is day after tomorrow
      if (hour < cutoffHour) {
        deliveryDate.setDate(deliveryDate.getDate() + 1);
      } else {
        deliveryDate.setDate(deliveryDate.getDate() + 2);
      }

      // Format date in French
      const days = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
      const months = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 
                      'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
      
      const dayName = days[deliveryDate.getDay()];
      const day = deliveryDate.getDate();
      const month = months[deliveryDate.getMonth()];

      if (deliveryDate.getDate() === now.getDate() + 1 && hour < cutoffHour) {
        deliveryDateEl.textContent = 'livré demain';
      } else {
        deliveryDateEl.textContent = `livré ${dayName} ${day} ${month}`;
      }
    }

    updateDeliveryDate();
    // Update every minute to catch day changes
    setInterval(updateDeliveryDate, 60000);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initSocialProof();
      initDeliveryPromise();
    });
  } else {
    initSocialProof();
    initDeliveryPromise();
  }

  // Re-initialize when sections are loaded (Shopify theme editor)
  document.addEventListener('shopify:section:load', function() {
    initSocialProof();
    initDeliveryPromise();
  });
})();



/**
 * Product page quantity selector — replaces the commented-out QuantityPicker
 * handlers in theme.js that were disabled due to customization conflicts.
 */
(function () {
  'use strict';

  function getInput(btn) {
    var selector = btn.closest('.quantity-selector--product');
    return selector ? selector.querySelector('.quantity-selector__value') : null;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action="decrease-picker-quantity"], [data-action="increase-picker-quantity"]');
    if (!btn) return;

    var input = getInput(btn);
    if (!input) return;

    var current = parseInt(input.value, 10) || 1;
    if (btn.dataset.action === 'increase-picker-quantity') {
      input.value = current + 1;
    } else {
      input.value = Math.max(1, current - 1);
    }
  });

  document.addEventListener('keyup', function (e) {
    if (!e.target.closest('.quantity-selector--product .quantity-selector__value')) return;
    var val = e.target.value;
    if (val !== '' && isNaN(val)) {
      e.target.value = Math.max(1, parseInt(val) || 1);
    }
  });

  document.addEventListener('focusout', function (e) {
    if (!e.target.closest('.quantity-selector--product .quantity-selector__value')) return;
    e.target.value = Math.max(1, parseInt(e.target.value, 10) || 1);
  });
})();
